import { User } from "../../types";

/*
 Il corpo di `POST /user/registration`, con cui l'amministratore crea un utente dal profilo
 azienda.

 Senza password. Prima il portale ne generava una a caso (`Math.random`, otto caratteri) e il
 backend la spediva in chiaro nell'email di benvenuto; ora l'email porta un link con cui è
 l'utente a impostarsela, e il backend il campo lo ignora. Mandarla ancora vorrebbe dire far
 viaggiare una password che nessuno usa, generata con un generatore non crittografico.
*/
export type CorpoRegistrazione = {
  firstName: string;
  lastName: string;
  username: string;
  email: string;
  isUsing2FA: boolean;
  role: number;
};

export function corpoRegistrazione(utente: User): CorpoRegistrazione {
  return {
    firstName: utente.firstName.trim(),
    lastName: utente.lastName.trim(),
    username: utente.username.trim(),
    email: utente.email.trim(),
    isUsing2FA: false,
    role: utente.role,
  };
}
